import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IBbitSelectDataRow } from '@bbitgmbh/bbit.utils';
import { I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { ComboboxOverlayRef, IComboboxOverlayData } from './combobox-overlay.ref';

@Component({
  selector: 'app-combobox-overlay',
  imports: [I18nPipe, NgIcon, CommonModule],
  templateUrl: './combobox-overlay.component.html',
  styleUrl: './combobox-overlay.component.scss',
})
export class ComboboxOverlayComponent {
  overlayRef = inject(ComboboxOverlayRef);

  public data: IComboboxOverlayData;
  public selectedIndex = signal(0);

  constructor() {
    this.data = this.overlayRef.getData();

    this.overlayRef
      .observeSelectCurrent()
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.select(this.data.values()?.[this.selectedIndex()]);
      });

    this.overlayRef
      .observeSelectNext()
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        const newIndex = this.selectedIndex() + 1;
        if (newIndex < this.data.values().length) {
          this.selectedIndex.set(newIndex);
        }
      });

    this.overlayRef
      .observeSelectPrevious()
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        if (this.selectedIndex() > 0) {
          this.selectedIndex.set(this.selectedIndex() - 1);
        }
      });
  }

  select(value: IBbitSelectDataRow): void {
    if (this.data.allowNewEntry() && this.data.values().length === 0) {
      this.overlayRef.close({ createNewEntry: true });
      return;
    }
    this.overlayRef.close({ selected: value });
  }

  createNewEntry(): void {
    this.overlayRef.close({ createNewEntry: true });
  }
}
